const UserType = {
    ADMIN: 1,
    APPLICANT: 2,
    RECRUITMENT_MANAGER: 3,
    HR_MANAGER: 4,
    HR_RECRUITMENT: 5,
    SYSTEM_ADMIN: 6
};

export default UserType;